const Statistics = Mach.requireModule('Statistics');
export const cid_home = 'c_waimai_c_overseas_1yjxcete'; // 搜索输入页
export const cid_search_result = 'c_sailor_c_fobhde7c'; // 搜索结果页
const page_source = Mach.env.schemeParams?.page_source || '-999'; //页面来源，从scheme上面取

export const SearchTypeNum = {
  popBrandSearches: 4,
  popularsearches: 3,
  history: 2,
  sug: 1,
  search: 0
};

export const searchPv = (recommend_keyword = '') => {
  Statistics.pv(cid_home, { recommend_keyword, page_source });
};

export const searchResultPv = (params = {}) => {
  Statistics.pv(cid_search_result, { page_source, ...params });
};

export const searchMc = (cid = cid_home, bid = '', params = {}) => {
  Statistics.click(cid, bid, params);
};
export const searchMv = (cid = cid_home, bid = '', params = {}) => {
  Statistics.view(cid, bid, params);
};

export const searchLx = (type = 'mc', cid = cid_home, bid = '', params = {}) => {
  type === 'mc' ? Statistics.click(cid, bid, params) : Statistics.view(cid, bid, params);
};

export const searchTag = (lab = {}, bid) => {
  Statistics.setTag && Statistics.setTag('sailor_c', {
    c_waimai_c_overseas_1yjxcete: {
      ...lab,
      bid,
    },
  });
};

export const searchResultTag = (lab = {}, bid) => {
  Statistics.setTag && Statistics.setTag('sailor_c', {
    c_sailor_c_fobhde7c: {
      ...lab,
      bid,
    },
  });
};
/**
 * 搜索引导页-前置搜索-关键词匹配类型
 */
export const PreSearchKeyMatchType = {
  MATCH_SUCCESS: 1, // 匹配成功
  MATCH_FAIL: 0, // 匹配失败
};
